import {
    JSMOverlayTemplate,
    SignupBackgroundLayout
} from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { ServiceCollectionLogo } from "@/components/signup/utils";
import { ExperimentView, experiments } from "@/utils/experiment";

import {
    CreateAWorkspaceText,
    Headings,
    WorkspacesAreWhereText
} from "../components";

const NewUserContent = () => {
    return (
        <>
            <Headings
                main={<CreateAWorkspaceText />}
                sub={<WorkspacesAreWhereText />}
            />
            <SiteActivation />
        </>
    );
};

export const NewUser = () => (
    <ExperimentView
        experiment={experiments.servCoLofiBackground}
        render={(value) =>
            value ? (
                <JSMOverlayTemplate size="sm">
                    <NewUserContent />
                </JSMOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<ServiceCollectionLogo />}
                    theme="yellow"
                >
                    <NewUserContent />
                </SignupBackgroundLayout>
            )
        }
    />
);
